import React from "react";
import configService from "../../services/config";
import defaultConfig from "../../config/default";
import prodConfig from "../../config/prod";
import stagingConfig from "../../config/staging";
import demoConfig from "../../config/oregon-demo";
import kubernetesConfig from "../../config/kubernetes";
import kubernetesLocalConfig from "../../config/kubernetes-local";
import localConfig from "../../config/local";
import devConfig from "../../config/dev";
import remoteDev from "../../config/remote-dev";
import oregonLocalConfig from "../../config/oregon-local";
import oregonStagingConfig from "../../config/oregon-staging";
import oregonProdConfig from "../../config/oregon-prod";
import nvirginiaStagingConfig from "../../config/nvirginia-staging";
import nvirginiaProdConfig from "../../config/nvirginia-prod";
import automationConfig from "../../config/automation";
import googleAnalyticsService from "../../services/googleAnalytics";
import MixpanelService from "../../services/mixpanel";
import {datadogRum} from "@datadog/browser-rum";
import uuidV4 from "uuid/v4";
import Resource from "../../utils/resourcesUtil";
import CardUtils from "../../utils/cardUtil";
import {fingerprint} from "../../utils/fingerprints/fingerprint";
import {sampling} from "../../utils/sampling/Sampling";
import {addLocaleData} from "react-intl";
import enLocaleData from "react-intl/locale-data/en";
import configureStoreTest from "../../store/configureStore.test";
import configureStoreProd from "../../store/configureStore.prod";
import configureStoreDev from "../../store/configureStore.dev";
import {syncHistoryWithStore} from "react-router-redux";
import {browserHistory, Router} from "react-router";
import {ReduxAsyncConnect} from "redux-connect";
import {loginUserCheckUp, trackUserSession} from "../../actions/auth/authWithOtp/authActions2";
import I18N from "../../components/i18n/i18n";
import {Provider} from "react-redux";
import routes from "../../routes";

export class FeatureFlagLoader extends React.Component {

  env;
  store;
  renderWithMiddleware;
  history;

  constructor(props) {
    super(props);
    /// -------------
    this.initEnvConfig();
    this.init();
    //---------------

  }

  initEnvConfig() {

    // -- real
    window.sunbitEnv = typeof sunbitEnv === "undefined" ? "dev" : sunbitEnv; // eslint-disable-line no-undef
    this.env = window.sunbitEnv;
    window.axios = window.axios || {}; // make lint aware of global axios
    // --

    // -- flag
    // window.sunbitEnv = 'oregon-staging';
    // this.env = window.sunbitEnv; // eslint-disable-line no-undef
    // console.log(this.env);
    // --

    configService.addConfig(defaultConfig);
    switch (this.env) {
      case "prod":
        configService.addConfig(prodConfig);
        break;
      case "staging":
        configService.addConfig(stagingConfig);
        break;
      case "oregon-demo":
      case "nvirginia-demo":
        configService.addConfig(demoConfig);
        break;
      case "kubernetes":
        configService.addConfig(kubernetesConfig);
        break;
      case "kubernetes-local":
        configService.addConfig(kubernetesLocalConfig);
        break;
      case "local":
        configService.addConfig(localConfig);
        break;
      case "dev":
        configService.addConfig(devConfig);
        break;
      case "remote-dev":
        configService.addConfig(remoteDev);
        break;
      case "oregon-local":
        configService.addConfig(oregonLocalConfig);
        break;
      case "oregon-staging":
        configService.addConfig(oregonStagingConfig);
        break;
      case "oregon-prod":
        configService.addConfig(oregonProdConfig);
        break;
      case "nvirginia-staging":
        configService.addConfig(nvirginiaStagingConfig);
        break;
      case "nvirginia-prod":
        configService.addConfig(nvirginiaProdConfig);
        break;
      case "automation":
        configService.addConfig(automationConfig);
        break;
      default:
        throw new Error(`Failed to configure ${this.env}`);
    }
  }

  init() {
    googleAnalyticsService.init(configService.getItem("googleAnalyticsTrackingId"));
    MixpanelService.init(configService.getItem("mixpanelToken"), this.env);

    let deviceId = localStorage.getItem("deviceId");
    if (!deviceId) {
      deviceId = uuidV4();
      localStorage.setItem("deviceId", deviceId);
    }
    deviceId = 'MY-SUNBIT-WEB-' + deviceId;

    if (!window.sunbitEnv || window.sunbitEnv === "automation") {
      datadogRum.addUserAction = () => {
      };
    } else {
      datadogRum.init({
        applicationId: '8f44686a-0a0f-454e-ba87-d81dc5aa07af',
        clientToken: 'pub274b24c3287a2e36aa71630e305ef31a',
        site: 'datadoghq.com',
        env: this.env,
        service: 'my-sunbit',
        version: '1.0.0',
        sampleRate: 100,
        trackInteractions: true
      });
      datadogRum.addRumGlobalContext('deviceId', deviceId);
    }

    Resource.init(configService.getItem("apiUrl"), deviceId);
    Resource.initCard(configService.getItem("apiUrlPci"), deviceId);
    CardUtils.init(
      configService.getItem("features"),
    );
    const samplingConfig = configService.getItem("sampling");
    if (!samplingConfig.disabled) {
      fingerprint().then((fingerprint) => {
        const {visitorId, requestId} = fingerprint;
        sampling(visitorId, requestId);
      });
    }

    addLocaleData(enLocaleData);

    if(process.env.NODE_ENV === 'test') {
      this.store = configureStoreTest();
    } if (process.env.NODE_ENV === 'production') {
      this.store = configureStoreProd();
    } else {
      this.store = configureStoreDev();
    }

// Create an enhanced history that syncs navigation events with the store
    this.history = syncHistoryWithStore(browserHistory, this.store);

    this.renderWithMiddleware = props => (
      <ReduxAsyncConnect {...props} helpers={Resource}/>
    );

    try {
      const userValidProps = ["firstName", "lastName"];
      const loginDataValidProps = [
        "access_token",
        "refresh_token",
        "expires_in",
        "date"
      ];
      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user")) || {};
      const loginData = JSON.parse(localStorage.getItem("loginData")) || {};
      const userProps = Object.keys(user);
      const loginDataProps = Object.keys(loginData);
      if (!token) {
        throw new Error("Missing token");
      }
      if (!loginDataValidProps.every(prop => loginDataProps.includes(prop))) {
        throw new Error("Invalid loginData");
      }
      if (!userValidProps.every(prop => userProps.includes(prop))) {
        throw new Error("Invalid userData");
      }
      // Until there is a user proof that he is not valid, keep him alive inside.
      this.store.dispatch(loginUserCheckUp(loginData, user));
      // Check if user is valid (if the token period has passed or not)
      const timeSinceLogin = Date.now() - loginData.date;
      if (timeSinceLogin < loginData.expires_in * 1000 / 2) {
        this.store.dispatch(trackUserSession());
      }

    } catch (e) {
      console.log("invalid session data stored"); // eslint-disable-line no-console
    }
  }

  render() {
    return <Provider store={this.store}>
      <I18N>
        <Router history={this.history} routes={routes} render={this.renderWithMiddleware}/>
      </I18N>
    </Provider>;
  }
}



// WEBPACK FOOTER //
// ./src/containers/FeatureFlagLoader/FeatureFlagLoader.js